// extracted by mini-css-extract-plugin
module.exports = {"modal":"PB","modalContent":"QB","modalOverlay":"RB","copy":"SB","modalBtnContainer":"TB","btnStay":"UB","disabled":"VB","btnContinue":"WB"};